import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Plus } from 'lucide-react'
import { Button } from '@ludus/ui'
import { CenteredPanel } from '@/shared/feedback/CenteredPanel.tsx'
import { LoadFailure } from '../components/LoadFailure.tsx'
import { ManagersTable } from '../components/ManagersTable.tsx'
import { NewManagerDialog } from '../components/NewManagerDialog.tsx'
import { useManagersScreen } from '../hooks/useManagersScreen.ts'

export function ManagersPage() {
  const { t } = useTranslation()
  const { managers, pipelines, isLoading, failure } = useManagersScreen()
  const [creating, setCreating] = useState(false)

  if (isLoading) return <CenteredPanel title={t('pages.managers.loading')} muted />
  if (failure) return <LoadFailure failure={failure} />

  return (
    <div className="flex w-full max-w-5xl flex-1 flex-col gap-6 p-4 sm:p-6">
      <header className="flex flex-wrap items-end justify-between gap-3 border-b border-border/60 pb-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-xl font-semibold text-foreground">{t('pages.managers.title')}</h1>
          <p className="text-xs text-muted">{t('pages.managers.subtitle')}</p>
        </div>
        <div className="flex items-center gap-3">
          {managers.length > 0 && (
            <span className="text-xs text-muted">
              {t('pages.managers.count', { count: managers.length })}
            </span>
          )}
          <Button variant="primary" size="sm" onClick={() => setCreating(true)}>
            <Plus className="h-3.5 w-3.5" aria-hidden="true" />
            {t('pages.managers.newManager.button')}
          </Button>
        </div>
      </header>

      {managers.length === 0 ? (
        <CenteredPanel
          title={t('pages.managers.empty.title')}
          body={t('pages.managers.empty.body')}
          muted
        />
      ) : (
        <ManagersTable managers={managers} pipelines={pipelines} />
      )}
      {creating && <NewManagerDialog onOpenChange={setCreating} />}
    </div>
  )
}
